<div class="status-bulk">
  <label mat-icon-button *ngFor="let bulkActionButton of buttons" [ngClass]="{ 'hiddenButtons': !buttonsActivated }">
    <input type="radio" name="bulk" value="{{ bulkActionButton.value }}" (click)="onClicked($event)" [disabled]="!buttonsActivated"/>
    <div class="bulk-content">
      <i [ngClass]="bulkActionButton.icon" title="{{ bulkActionButton.text | translate }}"></i>
    </div>
  </label>
</div>
